var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    rx: 2,
    fill: "var(--primary)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 24,
    height: 4,
    rx: 2,
    fill: "var(--primary)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 24,
    height: 4,
    rx: 2,
    fill: "var(--primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.7f29628dc9a0e92ddef1ada9460fbf71.svg";
export { ForwardRef as ReactComponent };